import React from 'react';
import { BodyText, Button, FlexRow, Grid, Header4Text, ModalWindow } from '../../../../../ui-toolkit';
import styled from 'styled-components';

interface IUnmatchConfirmationModalProps {
  onCloseModal: () => void;
  onUnmatch: () => void;
}

export const UnmatchConfirmationModal: React.FC<IUnmatchConfirmationModalProps> = ({ onUnmatch, onCloseModal }) => {
  return (
    <ModalWindow
      title={<Header4Text>Unmatch Deposit</Header4Text>}
      onClose={onCloseModal}
      width={`30vw`}
      footer={
        <FlexRow justifyContent={'flex-end'}>
          <Grid columnCount={2} justify-self="end" columnGap={'spacing3'}>
            <Button intent={'ghost'} onClick={onCloseModal} data-test-id={'cancel-button'}>
              Cancel
            </Button>
            <Button intent={'primary'} onClick={onUnmatch} data-test-id={'unmatch-button'}>
              Unmatch
            </Button>
          </Grid>
        </FlexRow>
      }
    >
      <StyledBodyText>Are you sure you want to unmatch this deposit?</StyledBodyText>
    </ModalWindow>
  );
};

const StyledBodyText = styled(BodyText)`
  display: flex;
  justify-self: left;
`;
